import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TCreateRegion,
  TCreateRegionSeasonResponse,
  TCreateRegionsSeason,
  TSeason,
  TRegion,
  TRegionsDetails,
  TRegionSeasonId,
  TUpdateRegion,
} from './regions.types.ts';
import type { TQueryParams } from '@/hooks/useAppSearchParams.tsx';

export const regionsApi = {
  getAllRegions: async (params?: TQueryParams) => {
    const response = await axios.get<TRegion>('regions', { params });

    return response.data;
  },
  getRegionById: async (id: number) => {
    const response = await axios.get<TRegionSeasonId>(`regions/${id}`);

    return response.data;
  },
  createRegion: async (region: TCreateRegion) => {
    const response = await axios.post<TRegion>('regions', region);

    return response.data;
  },
  updateRegion: async (payload: { id: number; region: TUpdateRegion }) => {
    const { id, region } = payload;
    const response = await axios.patch<TRegionsDetails>(`regions/${id}`, region);

    return response.data;
  },
  deleteRegion: async (id: number) => {
    const response = await axios.delete<TRegionsDetails>(`regions/${id}`);

    return response.data;
  },
  createRegionSeason: async (payload: { id: number; regionSeason: TCreateRegionsSeason }) => {
    const { id, regionSeason } = payload;

    const response = await axios.post<TCreateRegionSeasonResponse>(
      `regions/${id}/seasons`,
      regionSeason,
    );

    return response.data;
  },
  updateRegionSeason: async (payload: {
    id: number;
    seasonId: number;
    regionSeason: Partial<TCreateRegionsSeason>;
  }) => {
    const { id, seasonId, regionSeason } = payload;

    const response = await axios.patch<TCreateRegionSeasonResponse>(
      `regions/${id}/seasons/${seasonId}`,
      regionSeason,
    );

    return response.data;
  },
  deleteRegionSeason: async (payload: { id: number; seasonId: number }) => {
    const { id, seasonId } = payload;
    const response = await axios.delete<TSeason>(`regions/${id}/seasons/${seasonId}`);

    return response.data;
  },
};

export const regionsQueries = createQueryKeys('regions', {
  getAllRegions: (params?: TQueryParams) => ({
    queryKey: ['region', params],
    queryFn: () => regionsApi.getAllRegions(params),
  }),
  getRegionById: (id: number) => ({
    queryKey: ['region', id],
    queryFn: () => regionsApi.getRegionById(id),
  }),
});
